import React from 'react';

import LocalePrice from '@progymedia/gatsby-theme-boutik-ecommerce/src/utils/LocalePrice';
import { usePageLocalization } from '@sbi-international/boutik.gatsby.plugin.multilocale';
import { useProductPrice } from '@progymedia/gatsby-theme-boutik-ecommerce/src/context/store';

export default function ApplianceOptionsPrice(props: { code: string }) {
    const { currentLocale } = usePageLocalization();
    const { code } = props;

    const productPrice = useProductPrice(code)[0]?.finalPrice.value;
    let formatedPrice = productPrice
        ? LocalePrice(currentLocale, productPrice)
        : '';
    if (currentLocale === 'en_US') {
        formatedPrice = '';
    }
    return <span className='price'>{formatedPrice}</span>;
}
